import { Grid } from "@mui/material";
import React from "react";
import style from "./Card.module.css";

interface CardPropsDI {
  title?: string;
  body: React.ReactNode;
  alignement?: "horizontal" | "vertical";
  lessonIsApproved?: boolean;
}

/**
 * A wrapper for carded elements. When title is provided, has two alignement modes.
 */
const Card: React.FC<CardPropsDI> = (props) => {
  const alignement = props.alignement || "vertical";
  const lessonNotApprovedStyle =
    props.lessonIsApproved !== undefined ? true : false;

  if (!props.title) {
    return (
      <div
        className={
          lessonNotApprovedStyle
            ? `${style.card} ${style.lessonNotApproved}`
            : style.card
        }
      >
        {props.body}
      </div>
    );
  }

  return (
    <div className={style.card}>
      {alignement === "vertical" && (
        <Grid container>
          <Grid item xs={12}>
            <h3 className={style.card__title}>{props.title}</h3>
          </Grid>
          <Grid item xs={12}>
            {props.body}
          </Grid>
        </Grid>
      )}
      {alignement === "horizontal" && (
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 0, flexShrink: 0, flexBasis: "12%" }}>
            <div className={style.card__title}>{props.title} </div>
          </div>
          <div>{props.body}</div>
        </div>
      )}
    </div>
  );
};
export default Card;
